// extracted by mini-css-extract-plugin
export var mcpFrame = "mcp-frame_Odc0FjJ95f7ekyOR4S7Z";
export var mcpTabs = "mcp-tabs_HpTt06uM_9xd2YWWumje";